import { subscriptionType } from "./type";

const initialAuthState = {
  subscriptions: null,
  userSubscriptionsHistory: null,
  subscriptionDropdownList: [],
  subscription: null,
  isLoading: false,
  statusCode: null,
  activeTab: 0
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case subscriptionType.GET_SUBSCRIPTION_REQUEST:
      return { ...state, isLoading: true };
    case subscriptionType.GET_SUBSCRIPTION_SUCCESS:
      return { ...state, isLoading: false, subscriptions: action.payload.data };
    case subscriptionType.GET_SUBSCRIPTION_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case subscriptionType.GET_USER_SUBSCRIPTION_LIST_REQUEST:
      return { ...state, isLoading: true };
    case subscriptionType.GET_USER_SUBSCRIPTION_LIST_SUCCESS:
      return { ...state, isLoading: false, userSubscriptionsHistory: action.payload.data };
    case subscriptionType.GET_USER_SUBSCRIPTION_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case subscriptionType.GET_SUBSCRIPTION_DROPDOWN_REQUEST:
      return { ...state, isLoading: true };
    case subscriptionType.GET_SUBSCRIPTION_DROPDOWN_SUCCESS:
      return { ...state, isLoading: false, SubscriptionDropdown: action.payload.data };
    case subscriptionType.GET_SUBSCRIPTION_DROPDOWN_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case subscriptionType.GET_SINGLE_PROMO_CODE_REQUEST:
      return { ...state, isLoading: true, statusCode: null };
    case subscriptionType.GET_SINGLE_PROMO_CODE_SUCCESS:
      return { ...state, isLoading: false, subscription: action.payload };
    case subscriptionType.GET_SINGLE_PROMO_CODE_FAIL:
      return { ...state, isLoading: false, error: action.error, statusCode: action.statusCode };
    case subscriptionType.CHANGE_CUSTOMER_TAB:
      return { ...state, activeTab: action.payload };
    default:
      return state;
  }
};
